import { withBanner } from "./withBanner";
import { useBanner } from "./useBanner";
import { Provider } from "./Provider";
import { Container } from "./Container";

export const Banner = {
  Container,
  Provider,
  withBanner,
  useBanner,
};
